export default __webpack_public_path__ + "static/media/276.49875625.jpg";